var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTextDocumentCheck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 3195 3750",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M962 2653c-53 0-96-44-96-97 0-54 43-97 96-97h626c53 0 96 44 96 97 0 54-43 97-96 97H962zm0-1364c-53 0-96-43-96-96s43-96 96-96h1270c53 0 96 43 96 96s-43 96-96 96H962zm1069 2026c-41-33-48-93-15-135 33-41 93-48 135-15l292 231 556-680c34-41 94-47 135-14 41 34 47 94 14 135l-615 753c-33 41-93 47-134 14l-366-290zm-297 242c53 0 96 43 96 96s-43 96-96 96H223c-62 0-118-25-158-66-41-40-66-96-66-158V223c0-62 25-118 66-158 41-41 96-66 158-66h2747c62 0 118 25 158 66 41 41 66 96 66 158v1992c0 53-43 96-96 96s-96-43-96-96V223c0-9-4-16-9-22-6-6-14-9-22-9H224c-9 0-16 4-22 9-6 6-9 14-9 22v3302c0 9 4 16 9 22 6 6 14 9 22 9h1511zM962 1971c-53 0-96-43-96-96s43-96 96-96h1270c53 0 96 43 96 96s-43 96-96 96H962z",
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextDocumentCheck);
export default __webpack_public_path__ + "static/media/text-document-check.0f23defcf4b9e65df2140ada45f6517a.svg";
export { ForwardRef as ReactComponent };